var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full-screen"},[_c('p',[_c('md-icon',[_vm._v("warning")])],1),_c('p',[_vm._v("\n    "+_vm._s(_vm.message)+"\n  ")]),_c('div',{staticClass:"footer"},[_c('gl-logo-app')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }